<header class="shivsewa-navbar">
  <div class="shivsewa-navbar-wrapper">
    <div class="shivsewa-logo-section">
      <a href="/">
        <img
          src="assets/shiv-sewa-logo.svg"
          alt="ShivSewa Logo"
          class="shivsewa-logo"
        />
      </a>
    </div>

    <button
      class="shivsewa-menu-button"
      (click)="toggleMenu()"
      [attr.aria-expanded]="menuOpen"
    >
      <span class="shivsewa-hamburger-line"></span>
      <span class="shivsewa-hamburger-line"></span>
      <span class="shivsewa-hamburger-line"></span>
    </button>

    <nav
      class="shivsewa-navigation"
      [class.shivsewa-navigation-active]="menuOpen"
    >
      <a (click)="scrollTo('trips')" href="#trips" class="shivsewa-nav-item"
        >Popular Trips</a
      >
      <a (click)="scrollTo('fleet')" href="#fleet" class="shivsewa-nav-item"
        >Our Fleet</a
      >
      <a (click)="scrollTo('about')" href="#about" class="shivsewa-nav-item"
        >About Us</a
      >
      <button class="shivsewa-btn-whatsapp" (click)="openWhatsApp()">
        <img 
          src="assets/whatsapp-icon.svg" 
          alt="WhatsApp"
          class="ms-2" 
        /> Book on WhatsApp
      </button>
      <button class="shivsewa-btn-book" (click)="scrollTo('shivsewa-booking-form')">
        <img src="assets/car-icon.svg" alt="Shiv Sewa Cab Icon" class="ms-2" />
        Book Your Ride
      </button>
    </nav>
  </div>
</header>
